const CART_RESTORE_TTL = 10 * 60 * 1000; // 10 minutes

document.addEventListener('DOMContentLoaded', function () {
  const savedItemsRaw = localStorage.getItem('saved-cart-items');
  const reopenDrawer = localStorage.getItem('reopen-cart-drawer');
  const tokenRestoreReturn = localStorage.getItem('token-restore-return-url');
  console.log('[draft-order] DOMContentLoaded — savedItems:', !!savedItemsRaw, '| reopenDrawer:', !!reopenDrawer);

  // Step 4: landed somewhere after /cart/{token} restored the cart — go back to calling page
  if (tokenRestoreReturn) {
    localStorage.removeItem('token-restore-return-url');
    if (window.location.pathname !== tokenRestoreReturn) {
      window.location.href = tokenRestoreReturn;
      return;
    }
  }

  if (savedItemsRaw || reopenDrawer) {
    localStorage.removeItem('saved-cart-items');
    localStorage.removeItem('reopen-cart-drawer');

    const restoreAndOpen = async () => {
      if (savedItemsRaw) {
        const { token, savedAt } = JSON.parse(savedItemsRaw);
        if (token && Date.now() - savedAt < CART_RESTORE_TTL) {
          const cart = await (await fetch('/cart.js')).json();
          console.log('[draft-order] Cart on return — item_count:', cart.item_count);

          if (cart.item_count === 0) {
            // Use Shopify's cart permalink to restore the saved cart
            console.log('[draft-order] Cart empty, restoring via token:', token);
            localStorage.setItem('token-restore-return-url', window.location.pathname);
            localStorage.setItem('reopen-cart-drawer', '1');
            window.location.href = '/cart/' + token;
            return;
          }
        }
      }

      if (reopenDrawer) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        console.log('[draft-order] Dispatching cart:refresh');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    };

    restoreAndOpen();
  }
});

async function submitDraftOrder(btn, tags) {
  const { workerUrl, loginUrl, customerEmail, customerId, address1, city, country, zip } = btn.dataset;

  if (!customerEmail) {
    alert('Please log in before continuing.');

    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (cart.items && cart.items.length > 0) {
        localStorage.setItem('saved-cart-items', JSON.stringify({ token: cart.token, savedAt: Date.now() }));
        console.log('[draft-order] Cart token saved:', cart.token);
      }
    } catch (e) {
      console.error('[draft-order] Failed to save cart token:', e);
    }

    localStorage.setItem('reopen-cart-drawer', '1');
    window.location.href = loginUrl + '?return_to=' + encodeURIComponent(window.location.pathname);
    return;
  }

  const originalText = btn.innerText;
  btn.innerText = 'Processing...';
  btn.disabled = true;

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const address = { address1, city, country, zip };

    const response = await fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.items,
        email: customerEmail,
        customerId,
        address,
        tags,
      }),
    });

    if (response.ok) {
      alert('Thank you! We received your request! ');
      await fetch('/cart/clear.js', { method: 'POST' });
      window.location.href = '/';
    } else {
      throw new Error('API returned an error');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Sorry, an error occurred. Please try again later.');
    btn.innerText = originalText;
    btn.disabled = false;
  }
}

document.addEventListener('click', async function (e) {
  const quoteBtn = e.target.closest('#create-quo');
  if (quoteBtn) {
    e.preventDefault();
    await submitDraftOrder(quoteBtn, 'quote');
    return;
  }

  const placeOrderBtn = e.target.closest('#place-order');
  if (placeOrderBtn) {
    e.preventDefault();
    await submitDraftOrder(placeOrderBtn, 'draft-order');
  }
});
